export const FILTER_TYPE_SERVICES = 'service'
export const FILTER_TYPE_INDUSTRY = 'industry'
export const FILTER_TYPE_PLATFORMS = 'platforms'
export const FILTER_TYPE_TECHNOLOGY = 'technology'

export const ALERT_TYPE_LINK_COPY = 'ALERT_TYPE_LINK_COPY'

export const PLATE_TYPE_PORTFOLIO = 'PLATE_TYPE_PORTFOLIO'
export const PLATE_TYPE_INDUSTRY = 'PLATE_TYPE_INDUSTRY'

export const CHART_TYPE_TECHNOLOGIES = 'Technologies'

export const SOFTWARE_PRODUCT_SLUG = 'software-product'

export const CASE_STUDY_CLIENT =
  'Portfolio_item_Portfolioitem_CaseStudySections_Client'
export const CASE_STUDY_WYSIWYG =
  'Portfolio_item_Portfolioitem_CaseStudySections_Wysiwyg'
export const CASE_STUDY_STAGES =
  'Portfolio_item_Portfolioitem_CaseStudySections_Stages'
export const CASE_STUDY_ROADMAP =
  'Portfolio_item_Portfolioitem_CaseStudySections_Roadmap'
export const CASE_STUDY_FACTS =
  'Portfolio_item_Portfolioitem_CaseStudySections_Facts'
export const CASE_STUDY_QUOTE =
  'Portfolio_item_Portfolioitem_CaseStudySections_Quote'

export const DEVICE_FRAME_TYPE = {
  LAPTOP: 'Laptop',
  MOBILE: 'Mobile',
  CONSOLE: 'Console',
  GLASSES: 'Glasses',
  MONITOR: 'Monitor',
  TABLET: 'Tablet',
}

export const POSTS_PER_PAGE = {
  DESKTOP: 10,
  TABLET: 12,
  MOBILE: 7,
}

export const ORIGINS = {
  VISARTECH: 'https://www.visartech.com',
  WWW_VISARTECH: 'https://visartech.com',
}
